import styles from '@cp/pages/Paramount/Documentation/styles.module.scss';
import React from 'react';

function Strategy() {
  return (
    <div className={styles.documentationContainer}>
      <h2>Strategy</h2>
      <p>
        <strong>Definition</strong>: Defines scheduled actions to be taken on cases meeting
        specified conditions.
      </p>
      <p>
        <strong>Purpose</strong>:
      </p>
      <ul>
        <li>Associated with a timeline.</li>
        <li>Timelines can have multiple strategies.</li>
        <li>Strategies are anchored on the anchor date of the timeline.</li>
        <li>Specifies conditions, pre-actions, and actions for execution.</li>
      </ul>
      <p>
        <strong>Creating a Strategy</strong>:
      </p>
      <pre>
        <code>
          {`strategy "PresentMandateStrategy" {
  timeline = "PLCollectionsTimeline"
  description = "Present Mandate for emi &gt; 5000 cases"
  condition_type = "SEGMENT_BASED"
  condition = "{
    "setExpressions":{
      "final_result":{
        "entityOne":{
          "name":"UNPAID_ALL_MAN_FAILED",
          "entityType":"SUB_SEGMENT"},
          "operation":"MINUS",
          "entityTwo":{
            "name":"UNPAID_MP_EMI_MT_5K",
            "entityType":"SUB_SEGMENT"
  }}}}"
  dpad = [30..60, 90, 120]
  intent = "mandate"
  init_time = [11:47]
  pre_action = {}
  actions = {
  PRESENT_MANDATE {
  type = "static"
  amount_percentage = "100"
  balance_source = "SPADE"
}
}`}
        </code>
      </pre>
      <p>
        <strong>Strategy Field Explanation:</strong>
      </p>
      <ul>
        <li>
          <strong>timeline</strong>: Timeline name of which this strategy is part.
        </li>
        <li>
          <strong>description</strong>: Human-readable description of the Strategy.
        </li>
        <li>
          <strong>condition_type</strong>: Defines the condition parsing engine to use for
          evaluating the segment. Currently supports CDC_SEGMENT_BASED.
        </li>
        <li>
          <strong>condition</strong>: Defines the condition on the segment on which the Strategy has
          to be applied.
        </li>
        <li>
          <strong>dpad</strong>: DPAD stands for days past anchor date. It specifies the range of
          days past the anchor date for applying the strategy. It can be specified as a range using
          or individual days separated by commas.
        </li>
        <li>
          <strong>intent</strong>: Free text specifying the intent for creating this strategy.
        </li>
        <li>
          <strong>init_time</strong>: Initiation time of the strategy. If the same strategy has to
          be run multiple times in a day, pass a list of times in HH:MM format.
        </li>
        <li>
          <strong>pre_action</strong>: Actions to perform before the actual action. Can be used for
          setup or cleanup tasks required before the main action.
        </li>
        <li>
          <strong>actions</strong>: Contains actions to execute as part of this strategy. All
          executions will be carried out in the specified order; if any action fails, subsequent
          actions will not be executed.
        </li>
      </ul>
    </div>
  );
}

export default Strategy;
